// extracted by mini-css-extract-plugin
module.exports = {"react_time":"ReactTime_react_time__IZOxf","react_time__animating":"ReactTime_react_time__animating__2vJ1D"};